import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object({
    insightStatus: yup.string().required(
      formatMessage({
        id: 'STATUS_IS_REQUIRED',
        defaultMessage: 'Status is required',
      }),
    ),
  });

export default validationSchema;
